import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import UploadFileRoundedIcon from "@mui/icons-material/UploadFileRounded";
import { Box, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import { t } from "i18next";
import { useEffect, useState } from "react";
import Dropzone from "react-dropzone";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import CoreButton from "../../../app/core/components/CoreButton/CoreButton";
import CoreButtonIcon from "../../../app/core/components/CoreButtonIcon/CoreButtonIcon";
import CoreChip from "../../../app/core/components/CoreChip/CoreChip";
import CoreIAicon from "../../../app/core/components/CoreIAicon/CoreIAicon";
import CoreIconDelete from "../../../app/core/components/CoreIconDelete/CoreIconDelete";
import CoreInputField from "../../../app/core/components/CoreInputField/CoreInputField";
import CoreSelectObjArr from "../../../app/core/components/CoreSelect/CoreSelectObjArr";
import CoreSpinner from "../../../app/core/components/CoreSpinner/CoreSpinner";
import CoreTextArea from "../../../app/core/components/CoreTextArea/CoreTextArea";
import StudioFilter from "../../../app/core/components/UserFilter/StudioFilter";
import { useGetAllPromptQuery } from "../../api/admin/aiPromptApi";
import { useGetAdminCategoriesQuery } from "../../api/admin/categoriesApi";
import { useGetStudiosQuery } from "../../api/admin/gestisciStudioApi";
import {
  useCreateServiceMutation,
  useDeleteServiceMutation,
  useEditServiceMutation,
  useGetServiceIdQuery,
  useGetUploadURLQuery,
} from "../../api/admin/ServiziApi";
// ✅ Importa le API ServiceTask
import {
  useCreateServiceTaskMutation,
  useDeleteServiceTaskMutation,
  useGetServiceTasksQuery,
  useUpdateServiceTaskMutation,
} from "../../api/admin/serviceTaskApi";
import ServiceTaskManager from "./ServiceTaskManager";
import { doUploadImgService } from "./serviziSlide";

const DetailService = ({ service, handleClose }) => {
  const appConfig = useSelector((state) => state.app.appConfig);

  // ✅ Fix: Initialize all values as strings, never undefined
  const [formData, setFormData] = useState({
    Name: "",
    Description: "",
    IconUrl: "",
    fileImg: null,
    previewImage: null,
    mainCategoryId: "",
    categoryId: "",
    aiPromptId: "",
  });

  const [validationErrors, setValidationErrors] = useState({
    Name: "",
    Description: "",
  });
  const [subCategories, setSubCategoriesList] = useState([]);
  const [selectedSubCat, setSelectedSubCat] = useState([]);
  const [serviceTasks, setServiceTasks] = useState([]);
  const [studio, setStudio] = useState(null);
  const [debouncedInputStudioValue, setDebouncedInputStudioValue] =
    useState("");
  const [allStudio, setAllStudio] = useState(true);
  const [prompt, setPrompt] = useState(false);

  // ✅ Stato per paginazione tasks
  const [tasksPagination, setTasksPagination] = useState({
    currentPage: 1,
    startRow: 0,
    endRow: 100,
  });

  const isEditingMode = Boolean(service?.id);

  // ✅ Query per ottenere le tasks con API specifica
  const {
    data: serviceTasksData,
    isLoading: isLoadingTasks,
    refetch: refetchTasks,
  } = useGetServiceTasksQuery(
    {
      serviceId: service?.id || "",
      startRow: tasksPagination.startRow,
      endRow: tasksPagination.endRow,
      filter: {},
      sort: [],
    },
    {
      skip: !service?.id || !appConfig?.modules?.practice?.subtask, // Skip se non siamo in modalità editing
    }
  );

  // ✅ RTK QUERY HOOKS PER SERVICE TASKS
  const [createServiceTask, { isLoading: isCreatingTask }] =
    useCreateServiceTaskMutation();
  const [updateServiceTask, { isLoading: isUpdatingTask }] =
    useUpdateServiceTaskMutation();
  const [deleteServiceTask, { isLoading: isDeletingTask }] =
    useDeleteServiceTaskMutation();

  const isLoadingTaskOperations =
    isCreatingTask || isUpdatingTask || isDeletingTask || isLoadingTasks;

  // ===== BUSINESS LOGIC TASKS SEMPLIFICATA =====
  const handleCreateTaskForEditingMode = async (taskData) => {
    try {
      const payload = {
        serviceId: service.id,
        name: taskData.name,
        description: taskData.description,
        notes: taskData.notes,
        estimatedEffort: taskData.estimatedEffort,
        startingDate: new Date().toISOString(),
        endDate: taskData.endDate || new Date().toISOString(),
      };

      const response = await createServiceTask(payload);

      // ✅ Controlla Result per determinare success/error
      if (response.data?.Result === 1 && response.data?.Data) {
        // ✅ Aggiorna la lista tramite refetch invece di aggiornare manualmente
        refetchTasks();
        toast.success(t("TaskCreated"));
      } else {
        throw new Error(response.Exception || "Task creation failed");
      }
    } catch (error) {
      console.error("Errore creazione task:", error);
      toast.error(error.data?.Exception || t("TaskCreationError"));
    }
  };

  const handleEditTaskForEditingMode = async (
    originalTask,
    updatedTaskData
  ) => {
    try {
      const response = await updateServiceTask({
        id: originalTask.id,
        name: updatedTaskData.name,
        description: updatedTaskData.description,
        notes: updatedTaskData.notes,
        startingDate: originalTask.startingDate,
        endDate: updatedTaskData.endDate || originalTask.endDate,
        estimatedEffort: updatedTaskData.estimatedEffort,
        actualEffort: updatedTaskData.actualEffort || originalTask.actualEffort,
      });

      // ✅ Controlla Result per determinare success/error
      if (response.data?.Result === 1) {
        // ✅ Aggiorna la lista tramite refetch invece di aggiornare manualmente
        refetchTasks();
        toast.success(t("TaskUpdated"));
      } else {
        const errorMessage = response.data?.Exception || t("TaskUpdateError");
        console.error("Errore logico modifica task:", errorMessage);
        toast.error(errorMessage);
      }
    } catch (error) {
      console.error("Errore rete modifica task:", error);
      toast.error(error.data?.Exception || t("TaskUpdateError"));
    }
  };

  const handleDeleteTaskForEditingMode = async (taskToDelete) => {
    try {
      const response = await deleteServiceTask(taskToDelete.id);

      // ✅ Controlla Result per determinare success/error
      if (response.data?.Result === 1) {
        // ✅ Aggiorna la lista tramite refetch invece di aggiornare manualmente
        refetchTasks();
        toast.success(t("TaskDeleted"));
      } else {
        const errorMessage = response.data?.Exception || t("TaskDeleteError");
        console.error("Errore logico eliminazione task:", errorMessage);
        toast.error(errorMessage);
      }
    } catch (error) {
      console.error("Errore rete eliminazione task:", error);
      toast.error(error.data?.Exception || t("TaskDeleteError"));
    }
  };

  // ✅ Funzione per salvare tasks in modalità creazione - aggiunge tasks al payload
  const handleSaveTasksForCreation = () => {
    return serviceTasks.map((task) => ({
      name: task.name,
      description: task.description,
      notes: task.notes,
      estimatedEffort: task.estimatedEffort,
    }));
  };

  // ===== QUERIES ESISTENTI =====
  const { data: adminCategories } = useGetAdminCategoriesQuery();
  const macroCategories = adminCategories?.Data?.map((cat) => ({
    label: cat?.name,
    value: cat?.id,
  }));

  const { data: adminStudio } = useGetStudiosQuery({
    ...{ currentPage: 1, startRow: 0, endRow: 5 },
    value: debouncedInputStudioValue,
  });

  const { data: serviceData, isLoading: loadingService } = useGetServiceIdQuery(
    { id: service?.id, showTask: false }, // ✅ Non prendiamo più le task dal service
    {
      skip: !service,
    }
  );

  const { data: promptList, isLoading: loadingPrompt } = useGetAllPromptQuery();
  const promptData = promptList?.Data?.value.prompts
    .filter((el) => el.service === "DocumentComposition")
    ?.map((prompt) => ({
      label: prompt.name,
      value: prompt.id,
    }));

  const { data: urlData, refetch } = useGetUploadURLQuery();
  const dispatch = useDispatch();

  const [createService, { isLoading: isLoadingCreate }] =
    useCreateServiceMutation();
  const [editService, { isLoading: isLoadingEdit }] = useEditServiceMutation();
  const [deleteService, { isLoading: isLoadingDelete }] =
    useDeleteServiceMutation();

  const iconURLValid =
    formData.IconUrl !== "/img/placeholder-image.svg" ? formData.IconUrl : "";

  // ===== EFFECTS =====
  useEffect(() => {
    if (serviceData && serviceData.Data) {
      setFormData({
        Id: serviceData?.Data?.id || "",
        Name: serviceData?.Data?.name || "",
        Description: serviceData?.Data?.description || "",
        IconUrl: serviceData?.Data?.iconUrl || "",
        aiPromptId: serviceData?.Data?.aiPromptId || "",
      });
      if (serviceData?.Data?.aiPromptId) {
        setPrompt(true);
      }
      if (serviceData?.Data?.categories?.length > 0) {
        const arrayCat = serviceData?.Data?.categories?.map((el) => el.id);
        setSelectedSubCat(arrayCat);
      }

      setAllStudio(serviceData?.Data?.isForAll);

      if (
        serviceData?.Data?.activeStudios?.length > 0 &&
        serviceData?.Data?.isForAll === false
      ) {
        setStudio({
          id: serviceData?.Data?.activeStudios[0]?.id,
          label: serviceData?.Data?.activeStudios[0]?.name,
        });
      }
    }
  }, [serviceData]);

  // ✅ Effect per aggiornare la lista tasks quando arrivano i dati dall'API
  useEffect(() => {
    if (serviceTasksData?.Data?.items) {
      setServiceTasks(serviceTasksData.Data.items);
    }
  }, [serviceTasksData]);

  // ===== HANDLERS =====
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setValidationErrors({ ...validationErrors, [name]: "" });
  };

  const handleInputChangeSub = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setSelectedSubCat([...selectedSubCat, value]);
  };

  const handleSave = async () => {
    const errors = {};
    if (!formData.Name) errors.Name = t("FieldRequired");
    if (!formData.Description) errors.Description = t("FieldRequired");
    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      return;
    }

    // ===== GESTIONE TASKS IN MODALITÀ CREAZIONE =====
    let tasksForPayload = [];
    if (!isEditingMode && serviceTasks.length > 0) {
      tasksForPayload = handleSaveTasksForCreation();
    }

    try {
      const imgUrl = formData.fileImg ? await uploadIMG() : "";

      if (serviceData && serviceData.Data) {
        const editedService = {
          id: formData.Id,
          name: formData.Name,
          description: formData.Description,
          iconURL: imgUrl || iconURLValid,
          docCategories: selectedSubCat,
          isForAll: allStudio,
        };

        if (studio) editedService.studioId = studio.id;
        if (prompt) editedService.aiPromptId = formData.aiPromptId;

        await editService(editedService)
          .unwrap()
          .then((res) => {
            if (res.Result !== 1) {
              toast.error(t("Service") + " " + t("not edited"));
              return;
            } else {
              refetch();
              toast.success(t("ServiceUpdated"));
              handleClose();
            }
          });
      } else {
        const newService = {
          name: formData.Name,
          description: formData.Description,
          iconURL: imgUrl,
          docCategories: selectedSubCat,
          IsAvailableToUser: true,
          // ✅ Aggiungi tasks al payload se esistono
          ...(tasksForPayload.length > 0 && { tasks: tasksForPayload }),
        };

        if (studio) newService.studioId = studio.id;
        if (prompt) newService.aiPromptId = formData.aiPromptId;

        await createService(newService)
          .unwrap()
          .then((res) => {
            if (res.Result !== 1) {
              toast.error(t("ServiceNotCreated"));
              return;
            }
            toast.success(t("ServiceCreated"));
            handleClose();
          })
          .catch(() => {
            toast.error(t("ServiceNotCreated"));
          });
      }
    } catch (err) {
      toast.error(t("ReqErr"));
      console.log(err);
    }

    refetch();
  };

  const handleFileDrop = (acceptedFiles) => {
    const file = acceptedFiles[0];
    const reader = new FileReader();
    reader.onload = () => {
      setFormData((prev) => ({ ...prev, previewImage: reader.result }));
    };
    setFormData((prev) => ({ ...prev, fileImg: file }));
    reader.readAsDataURL(file);
  };

  const handleDeleteImage = async () => {
    setFormData((prev) => ({
      ...prev,
      previewImage: null,
      fileImg: null,
      IconUrl: "",
    }));
  };

  const uploadIMG = async () => {
    const linkURL = urlData.Data;
    let clearURL = "";
    if (linkURL) {
      const uploadFileUrl = linkURL;
      await dispatch(
        doUploadImgService({
          url: uploadFileUrl,
          file: new Blob([formData.fileImg]),
          type: formData.fileImg.type,
        })
      ).then((res) => {
        if (res.payload && res.payload.Exception) {
          toast.error(res.payload.Exception);
        }
      });
      clearURL = uploadFileUrl.split("?")[0];
      setFormData({
        ...formData,
        IconUrl: clearURL,
      });
    }
    return clearURL;
  };

  const handleMacroChange = (event) => {
    const selectedValue = event.target.value;
    const subCategories = adminCategories?.Data?.filter(
      (mC) => mC.id === selectedValue
    );

    setSubCategoriesList(
      subCategories[0].expenseCategories.map((sub) => ({
        label: sub?.name,
        value: sub?.id,
      }))
    );
    setFormData((prevFormData) => ({
      ...prevFormData,
      [event.target.name]: selectedValue,
    }));
  };

  const labelForCategories = (v, categories) => {
    if (categories)
      for (const macro of categories) {
        for (const sub of macro.expenseCategories) {
          if (sub.id === v)
            return sub.name.length > 18
              ? `${sub.name.substring(0, 20)}...`
              : sub.name;
        }
      }
  };

  const handleRemoveChip = (sub) => {
    const newSubCat = selectedSubCat.filter((item) => item !== sub);
    setSelectedSubCat(newSubCat);
  };

  const handleDeleteService = async () => {
    deleteService(serviceData.Data.id)
      .unwrap()
      .then((res) => {
        if (res.Exception) {
          toast.error(res.Exception);
        } else if (res.Result === 1) {
          toast.success(t("ServiceDeleted"));
        }
        handleClose();
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  const handleChangeRadio = (event) => {
    setAllStudio(event.target.value === "true");
  };

  const handleChangePromptRadio = (event) => {
    setPrompt(event.target.value === "true");
  };

  if (loadingService || loadingPrompt) {
    return <CoreSpinner />;
  }

  return (
    <div>
      <h2 className="text-center">
        {serviceData ? t("EditService") : t("CreateNewService")}{" "}
        {serviceData?.Data?.aiPromptId && <CoreIAicon />}
      </h2>

      <div className="flex space-x-10 p-4">
        <div className="w-1/2">
          <div className="flex flex-col">
            <div className="flex justify-between items-center pb-2">
              <h3 className="m-0">{"A chi è rivolto?"}</h3>

              <RadioGroup
                row
                value={allStudio}
                className="flex"
                onChange={handleChangeRadio}
              >
                <FormControlLabel
                  disabled={!!serviceData}
                  value={true}
                  control={<Radio size="small" />}
                  label={t("All")}
                />
                <FormControlLabel
                  disabled={!!serviceData}
                  value={false}
                  control={<Radio size="small" />}
                  label={t("Studio")}
                />
              </RadioGroup>
            </div>
            <StudioFilter
              disabled={allStudio || serviceData}
              selectedUser={studio}
              setSelectedUser={(e) => setStudio(e)}
              usersList={adminStudio?.Data?.items}
              setDebouncedInputUserValue={setDebouncedInputStudioValue}
              startAdornment={
                <>
                  <SearchRoundedIcon size={20} />
                </>
              }
            />
          </div>

          <CoreInputField
            label={t("Name")}
            name="Name"
            value={formData.Name}
            onChange={handleInputChange}
            fullWidth
            required
            error={Boolean(validationErrors.Name)}
            helperText={validationErrors.Name}
          />

          <div className="pt-8">
            <CoreTextArea
              label={t("Description")}
              name="Description"
              value={formData.Description}
              onChange={handleInputChange}
              fullWidth
              rows={4}
              required
              error={Boolean(validationErrors.Description)}
              helperText={validationErrors.Description}
            />
          </div>
          <div>
            <h3>{t("InsertServiceImg")}</h3>
            <div>
              {formData.previewImage || iconURLValid ? (
                <div className="flex flex-col justify-center items-center">
                  <div className="relative p-4">
                    <img
                      src={formData.previewImage || iconURLValid}
                      alt="Preview"
                      style={{
                        maxWidth: "100%",
                        maxHeight: "150px",
                        objectFit: "cover",
                      }}
                    />
                    <CoreIconDelete onDelete={handleDeleteImage} />
                    <div>
                      {formData.fileImg && (
                        <CoreIconDelete onDelete={handleDeleteImage} />
                      )}
                    </div>
                  </div>
                </div>
              ) : (
                <Dropzone
                  onDrop={handleFileDrop}
                  accept={{ "image/*": [], "application/pdf": [] }}
                >
                  {({ getRootProps, getInputProps }) => (
                    <div
                      className="flex w-full justify-center items-center p-4 text-center"
                      {...getRootProps()}
                      style={{
                        border: "2px dashed #ccc",
                        cursor: "pointer",
                      }}
                    >
                      <input {...getInputProps()} />
                      <Box display="flex" flexDirection="column">
                        <p className="text-center text-gray">{t("DropFile")}</p>
                        <CoreButtonIcon
                          icon={
                            <UploadFileRoundedIcon
                              className="text-gray"
                              sx={{ fontSize: 70 }}
                            />
                          }
                        />
                        <CoreButtonIcon
                          icon={<SearchRoundedIcon className="text-gray" />}
                          testo={t("Search")}
                          className="text-gray"
                        />
                      </Box>
                    </div>
                  )}
                </Dropzone>
              )}
            </div>
          </div>
        </div>

        <div className="w-1/2">
          <div className="space-y-4 ">
            {appConfig?.modules?.services?.prompt && (
              <div className="flex flex-col">
                <div className="flex justify-between items-center pb-2">
                  <h3 className="m-0">
                    {"Prompt"} <CoreIAicon />
                  </h3>

                  <RadioGroup
                    row
                    value={prompt}
                    className="flex"
                    onChange={handleChangePromptRadio}
                  >
                    <FormControlLabel
                      value={true}
                      control={<Radio size="small" />}
                      label={t("Yes")}
                    />
                    <FormControlLabel
                      value={false}
                      control={<Radio size="small" />}
                      label={t("No")}
                    />
                  </RadioGroup>
                </div>

                <CoreSelectObjArr
                  disabled={!prompt}
                  name="aiPromptId"
                  label="Seleziona Prompt"
                  value={formData.aiPromptId || ""}
                  items={promptData || []}
                  onChange={handleInputChange}
                />
              </div>
            )}
            <h3 className="mt-0">{"Seleziona le " + t("Categories")}</h3>
            <CoreSelectObjArr
              name="mainCategoryId"
              label={t("MacroCategory")}
              value={formData.mainCategoryId || ""}
              items={macroCategories || []}
              onChange={handleMacroChange}
            />

            <CoreSelectObjArr
              disabled={formData.mainCategoryId ? false : true}
              name="categoryId"
              label={t("SubCategory")}
              value={formData.categoryId || ""}
              items={subCategories || []}
              onChange={handleInputChangeSub}
            />
          </div>

          <div
            className={`mt-8 p-4 space-x-1 overflow-y-scroll ${
              appConfig?.modules?.services?.prompt ? "h-[19rem]" : "h-[25.5rem]"
            }`}
            style={{
              border: "1px solid lightgrey",
            }}
          >
            {selectedSubCat?.length > 0 ? (
              selectedSubCat.map(
                (v, index) =>
                  v !== "" && (
                    <CoreChip
                      className="mt-2"
                      key={index}
                      label={labelForCategories(v, adminCategories?.Data)}
                      variant="outlined"
                      onDelete={() => handleRemoveChip(v)}
                    />
                  )
              )
            ) : (
              <p className="text-gray h-full flex justify-center items-center m-0">
                Nessuna categoria selezionata
              </p>
            )}
          </div>
        </div>
      </div>

      {/* ✅ SEZIONE TASK MANAGER CON API INTEGRATE */}
      {appConfig?.modules?.practice?.subtask && (
        <div className="flex space-x-10 p-4">
          <ServiceTaskManager
            tasks={serviceTasks}
            onTasksChange={setServiceTasks}
            disabled={loadingService || loadingPrompt}
            // Props per modalità editing (passate solo se in editing)
            onAddTask={
              isEditingMode ? handleCreateTaskForEditingMode : undefined
            }
            onEditTask={
              isEditingMode ? handleEditTaskForEditingMode : undefined
            }
            onDeleteTask={
              isEditingMode ? handleDeleteTaskForEditingMode : undefined
            }
            isLoadingOperations={isLoadingTaskOperations}
            // ✅ Aggiungi supporto per paginazione se necessario
            totalTasks={serviceTasksData?.Data?.totalCount}
            onRefreshTasks={refetchTasks}
          />
        </div>
      )}

      <div className="flex w-full justify-around mt-10">
        {serviceData && (
          <CoreButton
            className="bg-red-700 btn-round border-red-700"
            variant="contained"
            testo={isLoadingDelete ? t("Wait") : t("Delete")}
            onClick={handleDeleteService}
            disabled={isLoadingDelete || isLoadingEdit}
          />
        )}
        <CoreButton
          className={"btn-round"}
          variant="contained"
          testo={
            isLoadingCreate ? t("Wait") : serviceData ? t("Save") : t("Create")
          }
          onClick={handleSave}
          disabled={isLoadingCreate || isLoadingEdit}
        />
      </div>
    </div>
  );
};

export default DetailService;
